module.exports = __webpack_public_path__ + "static/img/2.0e1ddec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/2.png
// module id = 5M38
// module chunks = 0